module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "list"
  }, [_c('div', [_c('table', {
    attrs: {
      "border": "1"
    }
  }, [_c('thead', [_c('tr', [_vm._t("columns")], 2)]), _vm._v(" "), _c('tbody', [_vm._t("datasource"), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalCount <= 0),
      expression: "totalCount <=0"
    }]
  }, [_vm._m(0)])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "operate-pages fx fx-x-between fx-y-center"
  }, [_c('div', {}, [_vm._t("operate")], 2), _vm._v(" "), _c('div', {
    staticClass: "fx-y-center"
  }, [_c('pages', {
    attrs: {
      "offset": _vm.offset,
      "count": _vm.count,
      "total-count": _vm.totalCount
    },
    on: {
      "handleOffset": _vm.handleOffset
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "20"
    }
  }, [_c('p', {
    staticClass: "p-20"
  }, [_vm._v("暂无数据 (˘•ω•˘)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-acd76e34","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/zui/Table.vue
// module id = 881
// module chunks = 0